/**
 * Breadcrumb-tabs navigation for the chat view.
 * Shared by chat.ts and chat-answers.ts to avoid circular dependencies.
 *
 * States:
 *   Chat tab active       → [Chat Packs | Chat]  (Chat highlighted)
 *   Chat Packs set list   → [Chat Packs | Chat]  (Chat Packs highlighted)
 *   Specific answer set   → [Chat Packs | Chat] › Set Name  (leaf highlighted)
 */

export function updateChatBreadcrumb(setTitle?: string): void {
  const chatCrumb = document.querySelector<HTMLElement>('.seg-btn[data-nav="chat"]');
  const answersCrumb = document.querySelector<HTMLElement>('.seg-btn[data-nav="answers"]');
  const leafSep = document.querySelector<HTMLElement>('.chat-crumb-leaf-sep');
  const leaf = document.querySelector<HTMLElement>('.chat-crumb-leaf');
  if (!chatCrumb || !answersCrumb || !leafSep || !leaf) return;

  const chatTabActive = document.getElementById('tab-chat')?.classList.contains('active');

  if (chatTabActive) {
    chatCrumb.classList.add('active');
    answersCrumb.classList.remove('active');
    leafSep.style.display = 'none';
    leaf.style.display = 'none';
  } else if (setTitle) {
    // Specific set: Answers is tappable (not active), leaf is current location
    chatCrumb.classList.remove('active');
    answersCrumb.classList.remove('active');
    leafSep.style.display = '';
    leaf.style.display = '';
    leaf.textContent = setTitle;
  } else {
    // Set list: Answers is active
    chatCrumb.classList.remove('active');
    answersCrumb.classList.add('active');
    leafSep.style.display = 'none';
    leaf.style.display = 'none';
  }
}
